import React from 'react'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import ErrorMessage from 'components/share/ErrorMessage'
import { PatchedPostMetricResult } from 'schemas/PostMetricResultSchema'
import { retrievePostMetrics } from '../utils/widgetData'

const EmptyResultGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<PatchedPostMetricResult>(widgetId)
  const { t } = useTranslation()
  const postMetrics = retrievePostMetrics(widgetData)

  if (isEmpty(postMetrics)) {
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  }
  return children
}

export default EmptyResultGuard
